import { Injectable, OnDestroy, inject } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class SessionService implements OnDestroy {
    private authService = inject(AuthService);

    private readonly SESSION_TIMEOUT = 60 * 60 * 1000;

    private inactivityTimer: ReturnType<typeof setTimeout> | null = null;
    private isActive = false;

    private readonly ACTIVITY_EVENTS = ['click', 'keydown', 'mousemove', 'touchstart', 'scroll'] as const;

    private boundOnActivity = () => this.onActivity();

    startMonitoring(): void {
        if (this.isActive) return;
        this.isActive = true;

        for (const event of this.ACTIVITY_EVENTS) {
            document.addEventListener(event, this.boundOnActivity, { passive: true });
        }

        this.resetTimer();
    }

    stopMonitoring(): void {
        this.isActive = false;

        for (const event of this.ACTIVITY_EVENTS) {
            document.removeEventListener(event, this.boundOnActivity);
        }

        this.clearTimer();
    }

    private onActivity(): void {
        this.resetTimer();
    }

    private resetTimer(): void {
        this.clearTimer();
        this.inactivityTimer = setTimeout(() => {
            this.onTimeout();
        }, this.SESSION_TIMEOUT);
    }

    private clearTimer(): void {
        if (this.inactivityTimer !== null) {
            clearTimeout(this.inactivityTimer);
            this.inactivityTimer = null;
        }
    }

    private onTimeout(): void {
        this.authService.logout();
    }

    ngOnDestroy(): void {
        this.stopMonitoring();
    }
}
